export const NUDGE_CLOSED_DEFAULTS = {
    fontSize: {
        propertyName: "Font Size (px)",
        propertyType: "number",
        propertyValue: 14,
    },
    textColor: {
        propertyName: "Text-Color",
        propertyType: "color",
        propertyValue: "#000000",
    },
    topPosition: {
        propertyName: "Margin (top)",
        propertyType: "number",
        propertyValue: 4,
    },
    rightPosition: {
        propertyName: "Margin (right)",
        propertyType: "number",
        propertyValue: 4,
    },
    positionMode: {
        propertyName: "Position Mode",
        propertyType: "select",
        propertyValue: "inside",
        propertyOptions: [
            { optionName: "Inside", optionValue: "inside" },
            { optionName: "Outside", optionValue: "outside" },
        ],
    },
    shape: {
        propertyName: "Button Shape",
        propertyType: "select",
        propertyValue: "auto",
        propertyOptions: [
            { optionName: "Auto", optionValue: "auto" },
            { optionName: "Circle", optionValue: "circle" },
            { optionName: "Rounded", optionValue: "rounded" },
            { optionName: "Square", optionValue: "square" },
            { optionName: "Pill", optionValue: "pill" },
        ],
    },
    width: {
        propertyName: "Width (px)",
        propertyType: "number",
        propertyValue: 28,
    },
    height: {
        propertyName: "Height (px)",
        propertyType: "number",
        propertyValue: 28,
    },
    padding: {
        propertyName: "Padding (px)",
        propertyType: "number",
        propertyValue: 0,
    },
    backgroundColor: {
        propertyName: "Background Color",
        propertyType: "color",
        propertyValue: "transparent",
    },
    borderColor: {
        propertyName: "Border Color",
        propertyType: "color",
        propertyValue: "#000000",
    },
    borderWidth: {
        propertyName: "Border Width (px)",
        propertyType: "number",
        propertyValue: 0,
    },
    borderStyle: {
        propertyName: "Border Style",
        propertyType: "select",
        propertyValue: "solid",
        propertyOptions: [
            { optionName: "None", optionValue: "none" },
            { optionName: "Dotted", optionValue: "dotted" },
            { optionName: "Dashed", optionValue: "dashed" },
            { optionName: "Solid", optionValue: "solid" },
        ],
    },
    borderRadius: {
        propertyName: "Border Radius (px)",
        propertyType: "number",
        propertyValue: 0,
    },
    shadowEnabled: {
        propertyName: "Shadow",
        propertyType: "checkbox",
        propertyValue: false,
    },
    shadowColor: {
        propertyName: "Shadow Color",
        propertyType: "color",
        propertyValue: "rgba(0, 0, 0, 0.2)",
    },
    shadowX: {
        propertyName: "Shadow X (px)",
        propertyType: "number",
        propertyValue: 0,
    },
    shadowY: {
        propertyName: "Shadow Y (px)",
        propertyType: "number",
        propertyValue: 2,
    },
    shadowBlur: {
        propertyName: "Shadow Blur (px)",
        propertyType: "number",
        propertyValue: 6,
    },
    shadowSpread: {
        propertyName: "Shadow Spread (px)",
        propertyType: "number",
        propertyValue: 0,
    },
    display: {
        propertyName: "Display",
        propertyType: "select",
        propertyValue: "inline-flex",
        propertyOptions: [
            { optionName: "Inline Flex", optionValue: "inline-flex" },
            { optionName: "Inline Block", optionValue: "inline-block" },
            { optionName: "Block", optionValue: "block" },
            { optionName: "None", optionValue: "none" },
        ],
    },
};
